
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/line",
      function () {
        return require("private-next-pages/android/local/line/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/line"])
      });
    }
  